<template>
    <div class="search-listing flight-listing loading-filters">
      <div class="flex-items">
        <div class="details-col">
          <div class="details-container">

            <div class="itinerary">
              <div class="segment">
                <div class="airline">
                  <div class="square"></div>
                </div>

                <div class="destination">
                  <div class="med"></div>
                  <div class="med"></div>
                </div>

                <div class="duration">
                  <div class="short"></div>
                  <div class="short"></div>
                </div>

                <div class="destination">
                  <div class="med"></div>
                  <div class="med"></div>
                </div>
              </div>

              <div class="round-trip-separator"></div>

              <div class="segment">
                <div class="airline">
                  <div class="square"></div>
                </div>

                <div class="destination">
                  <div class="med"></div>
                  <div class="med"></div>
                </div>

                <div class="duration">
                  <div class="short"></div>
                  <div class="short"></div>
                </div>

                <div class="destination">
                  <div class="med"></div>
                  <div class="med"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="price-col">
        </div>
      </div>
    </div>

</template>

<script>

export default {
  name: 'LoadingFlightListing'
}
</script>